export const duplicityFieldsItems = [
	['Nome', 'name'],
	['Telefone', 'phone'],
	['E-mail', 'email'],
	['Celular', 'mobile'],
	['CPF', 'cpf']
]

export const duplicityRequiredItems = [
	{
		type: 'Campos do Cliente',
		options: [...duplicityFieldsItems]
	},
	{
		type: 'Campos dos Negócios',
		options: [
			['Etapa do Funil', 'deal_funnel_stage_id', true],
			['Status do Funil', 'deal_funnel_stage_status_id'],
			['Produto', 'deal_product_id'],
			['Origem', 'deal_origin_id']
		]
	}
]

export const CustomerClientFieldsTyped = [
	{
		type: 'Campos do Cliente',
		options: [...duplicityFieldsItems]
	},
	{
		type: 'Campos dos Negócios',
		options: [
			['Origem', 'deal_origin_id']
		]
	}
]
